import _ from 'underscore';

/**
 * extend the select observable
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @param {FieldOption} fieldOption - field of property
 * @returns {undefined} - the function extend passed local directly
 */
export function select(local, attrs, fieldOption) {
  if (!_.contains(fieldOption.values, local())) {
    local(fieldOption.values[0]);
  }

  _.extend(local, {
    select: attrs.type === 'string' || !local.string ? local : local.string,
  });
}
